import * as React from 'react'
import { useCallback, useMemo } from 'react'

import { createSyntheticClinicView } from '@app/domain/form/form.helpers'
import { useVisitInstrumentResponses } from '@app/domain/instrument/instrument.hooks'

import {
  VisitUseCase,
} from '../../domain/visit/visit.interface'
import { ResponseHistoryTable } from '../patient/response-history/response-history-list'

import type {
  IDataInstrument} from '../../domain/visit/visit.interface';

interface IActiveFormProps {
  form: IDataInstrument
  visitId: string
}

export const ActiveForm = ({ form, visitId }: IActiveFormProps) => {
  const updatedForm = useMemo(() => {
    const clinicView =
      form.views?.find((v) => v.useCase === VisitUseCase.Clinic) ??
      createSyntheticClinicView(form.views)
    const views =
      form.views?.filter((v) => v.useCase === VisitUseCase.Clinic) ?? []
    return { ...form, views: [...views, clinicView] }
  }, [form])

  const { entries, editResponses } = useVisitInstrumentResponses(
    form.id,
    form.version,
    visitId,
  )

  const handleEditResponses = useCallback(
    (entryId: string, responses: Record<string, string>) => {
      editResponses(entryId, responses)
    },
    [editResponses],
  )

  return updatedForm ? (
    <ResponseHistoryTable
      entries={entries ?? []}
      hideHeader={true}
      instrumentId={updatedForm.id}
      instrumentVersion={updatedForm.version}
      onEditResponses={handleEditResponses}
    />
  ) : null
}
